import tokens from '@nike/design-system-base';

// all commented values are from design-system-base v^3.0.1
// {
//   "mobile": 0,
//   "tablet": 600,
//   "desktop": 960,
//   "largeDesktop": 1440,
//   "extraLargeDesktop": 1920
// }

var mediaQueries = {
  sm: "@media only screen and (min-width: ".concat(tokens.bp('mobile'), "px)"),
  // 0
  md: "@media only screen and (min-width: ".concat(tokens.bp('tablet'), "px)"),
  // 600
  lg: "@media only screen and (min-width: ".concat(tokens.bp('desktop'), "px)"),
  // 960
  xl: "@media only screen and (min-width: ".concat(tokens.bp('largeDesktop'), "px)"),
  // 1440
  xxl: "@media only screen and (min-width: ".concat(tokens.bp('extraLargeDesktop'), "px)") // 1920
};
export default mediaQueries;

// the "- 1" is so that the smallerThan ranges won't overlap with the mediaQueries min-width ranges
var getMaxWidth = function getMaxWidth(device) {
  return tokens.bp(device) - 1;
};
export var smallerThan = {
  // tokens.bp('mobile') is 0, so no need to have max-width 0
  md: "@media only screen and (max-width: ".concat(getMaxWidth('tablet'), "px)"),
  // 599
  lg: "@media only screen and (max-width: ".concat(getMaxWidth('desktop'), "px)"),
  // 959
  xl: "@media only screen and (max-width: ".concat(getMaxWidth('largeDesktop'), "px)"),
  // 1439
  xxl: "@media only screen and (max-width: ".concat(getMaxWidth('extraLargeDesktop'), "px)") // 1919
};